import * as React from "react";
import { AppState, store, Actions, IPageState } from './../appredux';
import { connect } from 'react-redux';
import { Theme, withStyles, WithStyles, Typography, FormControl, Grid, Button } from '@material-ui/core';
import HouseIcon from '@material-ui/icons/House';


import Pagination, { calculateRange } from "./../components/Pagination";
import TabelaZamki from "./historia/TabelaDoladowania";
import { TransProps, WithTranslation, withTranslation } from "react-i18next";




interface NadawcyProps extends WithStyles<typeof styles> {
    page: IPageState,

    windowWidth: number,
}

interface NadawcyState {
    
}

class NadawcyClass extends React.Component<NadawcyProps & WithTranslation & TransProps, NadawcyState>  {

    constructor(props: NadawcyProps & WithTranslation & TransProps) {
        super(props, {});
        this.state = {
           
        }
    }

    async componentDidMount() {
      
    }

    async componentDidUpdate(prevProps: NadawcyProps) {
      
    }


    // dajSerwisNadawcy = async (start: number = 1, end: number = 10) => {
    //     try {

    //       let tabela = []
            
    //         let serwisNadawcy : Result<Nadawcy> = new Result()
    //         serwisNadawcy = await SmsService.dajSmsNadawcyStatus0({ rekordOd: start.toString(), rekordDo: end.toString() })
                  
            
            
            
    //         await store.dispatch(Actions.pageState.setNadawcyTablica(serwisNadawcy.result));
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }


    updateSkip = async (aPage: number) => {
        const newSkip = (aPage - 1) * this.props.page.paginacjaPowiadomienia[2]

        await store.dispatch(Actions.pageState.setPaginacjaPowiadomienia([newSkip, aPage, this.props.page.paginacjaPowiadomienia[2]]));
        //this.dajSerwisNadawcy(newSkip +1, newSkip + this.props.page.paginacjaPowiadomienia[2])
    }

    noResults = () => {
        const { t, classes } = this.props;

        return (
            <div style={{ minHeight: "200px", margin: "auto" }}>
                <Typography variant="h6" component="h2" color="primary" style={{ padding: "50px", textAlign: "center", fontSize: "1rem" }}>
                    <b>{t("No Results")}</b>
                </Typography>
            </div>
        );
    }



    render = () => {
        const { classes } = this.props;
        let ilosc =  this.props.page.powiadomienia.length
        let tabela = this.props.page.powiadomienia
        tabela = tabela.slice(this.props.page.paginacjaPowiadomienia[0], this.props.page.paginacjaPowiadomienia[0] + this.props.page.paginacjaPowiadomienia[2])

        const range = calculateRange(ilosc, this.props.page.paginacjaPowiadomienia[2])

        return (
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
            >
                <Grid item style={{ width: "100%" }}>

           
                   
              {
                tabela.length === 0 ?
                  this.noResults() :
                  <>
                    <TabelaZamki
                      tableBody={tabela}
                      />

                    <Pagination
                      page={this.props.page.paginacjaPowiadomienia[1]}
                      range={range}
                      updateSkip={this.updateSkip}
                      //changeResultsPerPage={this.changeRowsPerPage}
                      resultsPerPage={this.props.page.paginacjaPowiadomienia[2]}
                      tableLength={ilosc}
                    />

                  </>}


                 

                </Grid>
            </Grid>
        )
    }
}

const styles = (theme: Theme) => ({
    fieldset: {
        marginBottom: '18px'
    },
    container: {
        margin: 'auto',
    },
    gridButton: {
        width: 'calc((100% )/4)',
        "@media screen and (max-width: 800px)": {
            width: "100%"
        },
    },
    input: {
        border: "2px solid lavender",
        borderRadius: "0px",
        fontSize: "14px",
        lineHeight: "14px",
        fontWeight: "bold" as "bold",
        textTransform: "none" as "none",
        padding: "14px 0px",
        whiteSpace: "pre" as "pre",
        "&:hover": {
            border: "2px solid lavender",
            background: "#007000",
            color: 'white',
        },
    },
    
    seagreen: {
        color: 'seagreen',
    },
});

// połączenie z Redux
const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});


export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(NadawcyClass))); 

